'use strict'

const protobuf = require('protocol-buffers')

const rpcProto = protobuf(require('./rpc.proto.js'))
const topicDescriptorProto = protobuf(require('./topic-descriptor.proto.js'))

exports = module.exports
exports.rpc = rpcProto
exports.td = topicDescriptorProto



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-floodsub/src/message/index.js
// module id = 254
// module chunks = 0